// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"a542bf2f","210":"4c846bdf","425":"a2fc24d7","453":"ba882c7e","536":"d4bc0956","543":"bb1189cc","614":"1a209f68","847":"9b79431b","873":"9c29ee07","882":"199bf34c","931":"5650c817","966":"67d91461"}[chunkId] + ".chunk.js";
};